import axios from "axios";
import qs from "qs";
import { Message, LoadingBar } from "iview";
import store from "@/store/index";
import logincheck from "./logincheck";
import { t } from "../lang/i18n";

axios.interceptors.request.use(
  config => {
    if (config.method == "post" && !config.FormData) {
      config.data = qs.stringify(config.data);
      //     }else{
      // config.headers['Content-Type'] = 'multipart/form-data';
      //     }
      // config.headers['Content-Type'] = 'application/x-www-from-urlencoded'
    }
    LoadingBar.start();
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  res => {
    LoadingBar.finish();
    let { data } = res;
    if (data.State == 0 && (data.Data || data.Data === 0)) {
      // 数据转换，去掉多余的Value字段
      let newdata = JSON.stringify(data.Data);
      if (newdata.indexOf(':{"Value":') > -1) {
        newdata = newdata.replace(/\{\"Value\"\:(\d+(\.\d+)?)\}/g, "$1");
        data.Data = JSON.parse(newdata);
      }
      return data.Data;
    }
    if (data.State == 100) {
      store.commit("user/logstate", false);
      store.commit("user/info", false);
      store.commit("user/safe", false);
      data.Error = t("msg.m81");
      logincheck();
    }
    return {
      err: data.State,
      msg: data.Error,
      throw: () => {
        Message[data.State ? "error" : "success"](data.Error);
      }
    };
  },
  error => {
    LoadingBar.error();

    // 检查是否网站维护
    fetch("/SystemStickUp.json?v=" + Date.now()).then(res => {
      if (res.ok) window.location.reload();
    });

    return {
      err: 500,
      msg: t("msg.m77"),
      throw: () => {
        Message.error(t("msg.m77"));
      }
    };
  }
);

// 只获取一次数据
export const getOnce = url => {
  if (!window.$getOnceCache) window.$getOnceCache = {};
  let key = url.replace(/\//g, "_");
  return new Promise((resolve, reject) => {
    if (window.$getOnceCache[key]) {
      let clone = JSON.stringify(window.$getOnceCache[key]);
      resolve(JSON.parse(clone));
    } else {
      axios.get(url).then(res => {
        if (!res.err) window.$getOnceCache[key] = res;
        let clone = JSON.stringify(res);
        resolve(JSON.parse(clone));
      });
    }
  });
};

export const post = axios.post;
export const get = axios.get;
export default {
  install(Vue) {
    Vue.prototype.$axios = axios;
  }
};
